import { render, staticRenderFns } from "./Mails.vue?vue&type=template&id=89362c8e&scoped=true&"
import script from "./Mails.vue?vue&type=script&lang=js&"
export * from "./Mails.vue?vue&type=script&lang=js&"
import style0 from "./Mails.vue?vue&type=style&index=0&id=89362c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89362c8e",
  null
  
)

component.options.__file = "Mails.vue"
export default component.exports